window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.reports = window.locales.am.reports || {};window.locales.am.reports.reports = window.locales.am.reports.reports || {};window.locales.am.reports.reports = {...window.locales.am.reports.reports, ...{
    "confirm_title": "እርግጠኛ ነዎት?",
    "confirm": "አረጋግጥ",
    "cancel": "ሰርዝ",
    "action_failed": "ለውጡ አልተቀመጠም። እባክዎ እንደገና ይሞክሩ።",
    "date_range_interval": "የቀን ክልል",
    "date_range_start": "የመጀመሪያ ቀን",
    "date_range_finish": "የመጨረሻ ቀን",
    "date_range_label_last_days": "{value, plural, one {የመጨረሻ # ቀን} other {የመጨረሻ # ቀናት}}",
    "date_range_label_last_weeks": "{value, plural, one {የመጨረሻ # ሳምንት} other {የመጨረሻ # ሳምንታት}}",
    "date_range_label_last_months": "{value, plural, one {የመጨረሻ # ወር} other {የመጨረሻ # ወራት}}",
    "date_range_label_since_date": "ከ {start}",
    "date_range_label_between_dates": "በ {start} እና {end} መካከል",
    "filter_search_placeholder": "ፈልግ...",
    "maintenance_message": "ሪፖርቶች በአሁኑ ጊዜ መደበኛ ጥገና እያደረጉ ነው። ብዙም ሳይቆዩ እባክዎ እንደገና ይሞክሩ!",
    "no_report_loaded_message": "ከላይ ያለውን ማጣሪያ ይምረጡ። ውሂብን ለመጫን <refreshButton>አድስ</refreshButton> የሚለውን ጠቅ ያድርጉ።",
    "no_results_found_message": "ምንም ውጤቶች አልተገኙም! ማጣሪያዎችን ያስተካክሉ ወይም እንደገና ለመጀመር <clearButton>አጽዳ</clearButton> የሚለውን ጠቅ ያድርጉ።",
    "report_load_failed": "ሪፖርቱ አልተጫነም። እባክዎ እንደገና ይሞክሩ።",
    "activity": "የእንቅስቃሴ ሪፖርት",           
    "apply": "ያመልክቱ",           
    "clear": "ያጽዱ",           
    "completed_subtext": "ተጠናቋል",           
    "program": "ፕሮግራም",
    "course_activity": "የኮርስ እንቅስቃሴ",           
    "date_range_interval_between": "መካከል",           
    "date_range_interval_last": "የመጨረሻ",           
    "date_range_interval_since": "ከ",           
    "date_range_label_show_all": "ሁሉንም አሳይ",           
    "date_range_unit_days": "ቀናት",           
    "date_range_unit_months": "ወራት",           
    "date_range_unit_weeks": "ሳምንታት",           
    "export_as_csv": "እንደ CSV አድርገው ወደውጪ ይላኩ",           
    "file_name_activity_report": "users_activity",           
    "file_name_course_activity": "user_courses_activity",           
    "filter_label_username_or_name": "የተጠቃሚ ስም ወይም ስም",           
    "filter_label_cohorts": "Cohorts",           
    "filter_label_courses": "ኮርሶች",           
    "filter_label_courses_completed": "ኮርሶች ተጠናቅቀዋል",           
    "filter_label_courses_started": "ኮርሶች ተጀምረዋል",           
    "filter_label_groups": "ቡድኖች",           
    "filter_label_institutions": "ተቋማት",           
    "filter_label_roles": "ደርሻዎች",           
    "filter_label_sign_up_codes": "የምዝገባ ኮዶች",           
    "filter_label_lessons": "ትምህርቶች",
    "filter_label_locale": "አካባቢያዊ",
    "filter_label_client_types": "ደንበኛ",
    "filter_placeholder_all": "ሁሉም",
    "filter_placeholder_text": "የያዘው...",           
    "in_progress": "ተመዝግቧል?",           
    "last_seen": "ለመጨረሻ ጊዜ የታየው",           
    "mark_as_not_started": "አልተጀመረም ብለው ምልክት ያድርጉ",           
    "reset_timer_time_left": "ጊዜ ቆጣሪውን ዳግም ያስጀምሩ ({timeLeft} ግራ)",           
    "reset_timer_time_expired": "ጊዜ ቆጣሪውን ዳግም ያስጀምሩ (ምንም ጊዜ አይቀርም)",           
    "reset_timer_timer_not_started": "ጊዜ ቆጣሪው አልጀመረም",           
    "no_user_selected": "ምንም ተጠቃሚ አልተመረጠም",           
    "pagination_limit": "ገደብ፡ {limit}",           
    "pagination_results_found": "{num, plural, one {# ውጤት ተገኝቷል} other {# ውጤቶች ተገኝተዋል}}",
    "quick_search_placeholder": "ውጤቶችን ያጣሩ...",           
    "quick_search_reset": "ማጣሪያን ዳግም ያስጀምሩ",           
    "refresh": "አድስ",           
    "registered_x": "ተመዝግቧል {date}",           
    "report_title_placeholder": "ሪፖርት",           
    "report_title_users": "ተጠቃሚዎች",           
    "report_title_player_lesson_sessions": "የትምህርት ክፍለ ጊዜያት",           
    "report_title_editor_lesson_sessions": "የአርታዒ ክፍለ ጊዜያት",           
    "reports_title": "ሪፖርቶች",           
    "reset_course_confirm": "ይህ ለተማሪው እንዳልተጀመረ ሆኖ እንዲታይ ኮርሱን እንደገና ያስጀምራል። ይቀጥላሉ?",           
    "reset_timer_confirm": "ተጠቃሚው ዳግም ለመክፈት እንዲችል ይህ በፈተናው ላይ የሰአት ቆጣሪው ዳግም እንዲጀምር ያደርጋል። ይቀጥላሉ?",           
    "reset_at": "ዳግም ያስጀምሩ",           
    "show_not_started": "ያልተጀመሩ ኮርሶችን አሳይ",           
    "started": "ጀምሯል",           
    "th_name": "ስም",           
    "th_registered": "ተመዝግቧል",           
    "th_account_id": "የተጠቃሚ ስም",           
    "th_client_type": "ደንበኛ",           
    "th_courses": "ኮርሶች",           
    "th_course": "ኮርስ",           
    "th_lesson": "ትምህርት",           
    "th_lessons": "ትምህርቶች",           
    "th_status": "ሁኔታ",           
    "th_started": "ጀምሯል",           
    "th_completed": "ተጠናቋል",           
    "th_total_time": "ጠቅላላ ጊዜ",           
    "th_assessment_group": "መመዘኛ",           
    "th_assessment_first": "የመጀመሪያ",           
    "th_assessment_best": "ምርጥ",           
    "th_assessment_score_first": "የመጀመሪያ ነጥብ",           
    "th_assessment_score_best": "ምርጥ ነጥብ",           
    "th_assessment_attempts_total": "የማጠናቀቂያ ብዛቶች",           
    "th_last_seen": "ለመጨረሻ ጊዜ የታየው",           
    "th_started_in_this_session": "የመጀመሪያ ክፍለ ጊዜ",           
    "th_completed_in_this_session": "ተጠናቋል",           
    "th_save_count": "ተቀምጧል",           
    "to_use_user_report": "ይህን ሪፖርት ለመጠቀም፣ በ <strong>እንቅስቃሴ ሪፖርት</strong> ውስጥ ተጠቃሚዎችን ያግኙ፣ ከዚያም እዚህ ጋር የእነርሱን ዝርዝሮች ለማየት የተጠቃሚውን ኢሜይል ጠቅ ያድርጉ።",           
    "user": "የተጠቃሚ ዝርዝር",           
    "view_activity_report": "የእንቅስቃሴ ሪፖርት ይመልከቱ",           
    "x_available_courses": "{num} የሚገኙ ኮርሶች",           
    "x_completed": "{num} ተጠናቋል",           
    "x_in_progress": "{num} በሂደት ላይ",           
    "status_started": "ጀምሯል",           
    "status_not_started": "አልተጀመረም",           
    "status_completed": "ተጠናቋል",           
    "lock": "ቆልፍ",
    "unlock": "ክፈት",
    "lock_course_confirm": "ተጠቃሚው እንዳይከፍተው ይህ ኮርሱን ይቆልፋል። ይቀጥሉ?",
    "unlock_course_confirm": "ተጠቃሚው እንዲከፍተው ይህ ኮርሱን ይከፍታል። ይቀጥሉ?"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.reports = window.locales.ar.reports || {};window.locales.ar.reports.reports = window.locales.ar.reports.reports || {};window.locales.ar.reports.reports = {...window.locales.ar.reports.reports, ...{
    "confirm_title": "هل أنت متأكد؟",
    "confirm": "تأكيد",
    "cancel": "إلغاء",
    "action_failed": "لم يتم حفظ التغيير. يرجى إعادة المحاولة.",
    "date_range_interval": "النطاق الزمني",
    "date_range_start": "تاريخ البدء",
    "date_range_finish": "تاريخ الانتهاء",
    "date_range_label_last_days": "{value, plural, one {آخر # يوم} other {آخر # أيام}}",
    "date_range_label_last_weeks": "{value, plural, one {آخر # أسبوع} other {آخر # أسابيع}}",
    "date_range_label_last_months": "{value, plural, one {آخر # شهر} other {آخر # أشهر}}",
    "date_range_label_since_date": "منذ {start}",
    "date_range_label_between_dates": "بين {start} و{end}",
    "filter_search_placeholder": "بحث...",
    "maintenance_message": "تخضع التقارير حالياً لأعمال الصيانة الروتينية. يرجى إعادة المحاولة مرةً أخرى قريباً!",
    "no_report_loaded_message": "حدد خيارات التصفية أعلاه. انقر <refreshButton>تحديث</refreshButton> لتحديث البيانات.",
    "no_results_found_message": "لم يتم العثور على أية نتائج! قُم بضبط التصفيات أو انقر <clearButton>مسح</clearButton> للبدء من جديد.",
    "report_load_failed": "لم يتم تحميل التقرير. يرجى إعادة المحاولة.",
    "activity": "تقرير النشاط",           
    "apply": "تطبيق",           
    "clear": "مسح",           
    "completed_subtext": "مكتملة",           
    "program": "البرنامج",
    "course_activity": "نشاط الدورة",           
    "date_range_interval_between": "بين",           
    "date_range_interval_last": "آخر",           
    "date_range_interval_since": "منذ",           
    "date_range_label_show_all": "عرض الكل",           
    "date_range_unit_days": "أيام",           
    "date_range_unit_months": "أشهر",           
    "date_range_unit_weeks": "أسابيع",           
    "export_as_csv": "CSV تحميل بصيغة",           
    "file_name_activity_report": "نشاط_المستخدمين",           
    "file_name_course_activity": "نشاط_دورات_المستخدم",           
    "filter_label_username_or_name": "اسم المستخدم أو الاسم",           
    "filter_label_cohorts": "المجموعات",           
    "filter_label_courses": "الدورات",           
    "filter_label_courses_completed": "الدورات المكتملة",           
    "filter_label_courses_started": "الدورات التي تم البدء فيها",           
    "filter_label_groups": "المجموعات",           
    "filter_label_institutions": "المؤسسات",           
    "filter_label_roles": "الأدوار",           
    "filter_label_sign_up_codes": "أكواد الاشترك",           
    "filter_label_lessons": "الدروس",
    "filter_label_locale": "الموقع",
    "filter_label_client_types": "الزبون",
    "filter_placeholder_all": "الكل",
    "filter_placeholder_text": "تحتوي على...",           
    "in_progress": "قيد التنفيذ",           
    "last_seen": "آخر مشاهدة",           
    "mark_as_not_started": "وضع علامة لم يتم البدء فيها",           
    "no_user_selected": "لم يتم تحديد العضو",           
    "pagination_results_found": "{num, plural, zero {لم يتم العثور على نتائج} one {تم العثور على نتيجة واحدة} two {تم العثور على نتيجتين} few {تم العثور على # نتائج} many {تم العثور على # نتيجة} other {تم العثور على # نتيجة}}",
    "quick_search_placeholder": "نتيجة التصفية...",           
    "quick_search_reset": "إعادة تعيين التصفية",           
    "refresh": "تحديث",           
    "registered_x": "تم التسجيل في {date}",           
    "report_title_placeholder": "التقرير",           
    "report_title_users": "المستخدمون",           
    "report_title_player_lesson_sessions": "جلسات الدرس",           
    "report_title_editor_lesson_sessions": "جلسات المحرر",           
    "reports_title": "التقارير",           
    "reset_course_confirm": "سوف يؤدي هذا إلى إعادة تعيين الدورة كي تظهر للدارس وكأنها لم يتم البدء فيها. هل تريد المتابعة؟",           
    "reset_at": "إعادة التعيين",           
    "show_not_started": "عرض الدورات التي لم يتم البدء فيها",           
    "started": "تم البدء فيها",           
    "th_name": "الاسم",           
    "th_registered": "تم التسجيل",           
    "th_account_id": "اسم المستخدم",           
    "th_client_type": "الزبون",           
    "th_courses": "الدورات",           
    "th_course": "الدورة",           
    "th_lesson": "الدرس",           
    "th_lessons": "الدروس",           
    "th_status": "الحالة",           
    "th_started": "تم البدء فيها",           
    "th_completed": "مكتملة",           
    "th_total_time": "الوقت الكلي",           
    "th_assessment_group": "التقييم",           
    "th_assessment_first": "الأول",           
    "th_assessment_score_first": "النتيجة الأولى",           
    "th_assessment_attempts_total": "# مرات الإكمال",           
    "th_last_seen": "آخر ظهور",           
    "th_started_in_this_session": "الدورة الأولى",           
    "th_completed_in_this_session": "مكتملة",           
    "th_save_count": "يحفظ",           
    "to_use_user_report": "لاستخدام هذا التقرير، ابحث عن المستخدمين في <strong>تقرير النشاط</strong>، ثم انقر فوق البريد الإلكتروني للمستخدم لعرض تفاصيله هنا.",           
    "user": "معلومات المستخدم",           
    "view_activity_report": "عرض تقرير النشاط",           
    "x_available_courses": "{num} الدورات المتاحة",           
    "x_completed": "{num} مكتملة",           
    "x_in_progress": "{num} قيد التنفيذ",           
    "status_started": "تم البدء فيها",           
    "status_not_started": "لم يتم البدء فيها",           
    "status_completed": "مكتملة",           
    "pagination_limit": "الحد: {limit}",
    "th_assessment_best": "الأفضل",
    "th_assessment_score_best": "أفضل نتيجة",
    "reset_timer_time_left": "إعادة ضبط المؤقت ({timeLeft} متبقية)",
    "reset_timer_time_expired": "ريسيت تيمر (لا يوجد وقت متبقي)",
    "reset_timer_timer_not_started": "تيمر لم تبدأ",
    "reset_timer_confirm": "سيؤدي هذا إلى إعادة تعيين الموقت على الامتحان بحيث يمكن للمستخدم فتحه مرة أخرى. تقدم؟",
    "lock": "قفل",
    "unlock": "الغاء القفل",
    "lock_course_confirm": "سيؤدي هذا إلى قفل الدورة التدريبية حتى لا يتمكن المستخدم من فتحها. يتابع؟",
    "unlock_course_confirm": "سيؤدي هذا إلى فتح الدورة التدريبية حتى يتمكن المستخدم من فتحها. يتابع؟"
}
};window.locales.en = window.locales.en || {};window.locales.en.reports = window.locales.en.reports || {};window.locales.en.reports.reports = window.locales.en.reports.reports || {};window.locales.en.reports.reports = {...window.locales.en.reports.reports, ...{
    "confirm_title": "Are you sure?",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "action_failed": "The change did not save. Please try again.",
    "date_range_interval": "Date range",
    "date_range_start": "Start date",
    "date_range_finish": "End date",
    "date_range_label_last_days": "{value, plural, one {Last # day} other {Last # days}}",
    "date_range_label_last_weeks": "{value, plural, one {Last # week} other {Last # weeks}}",
    "date_range_label_last_months": "{value, plural, one {Last # month} other {Last # months}}",
    "date_range_label_since_date": "Since {start}",
    "date_range_label_between_dates": "Between {start} and {end}",
    "filter_search_placeholder": "Search...",
    "maintenance_message": "Reports are currently undergoing routine maintenance. Please try again shortly!",
    "no_report_loaded_message": "Select filter options above. Click <refreshButton>Refresh</refreshButton> to load data.",
    "no_results_found_message": "No results found! Adjust filters or click <clearButton>Clear</clearButton> to start over.",
    "report_load_failed": "The report did not load. Please try again.",
    "activity": "Activity Report",
    "apply": "Apply",
    "clear": "Clear",
    "completed_subtext": "Completed",
    "program": "Program",
    "course_activity": "COURSE ACTIVITY",
    "date_range_interval_between": "Between",
    "date_range_interval_last": "Last",
    "date_range_interval_since": "Since",
    "date_range_label_show_all": "Show all",
    "date_range_unit_days": "days",
    "date_range_unit_months": "months",
    "date_range_unit_weeks": "weeks",
    "export_as_csv": "Export as CSV",
    "file_name_activity_report": "users_activity",
    "file_name_course_activity": "user_courses_activity",
    "filter_label_username_or_name": "Username or name",
    "filter_label_cohorts": "Cohorts",
    "filter_label_courses": "Courses",
    "filter_label_courses_completed": "Courses Completed",
    "filter_label_courses_started": "Courses Started",
    "filter_label_groups": "Groups",
    "filter_label_institutions": "Institutions",
    "filter_label_roles": "Roles",
    "filter_label_sign_up_codes": "Sign Up Codes",
    "filter_label_lessons": "Lessons",
    "filter_label_locale": "Locale",
    "filter_label_client_types": "Client",
    "filter_placeholder_all": "All",
    "filter_placeholder_text": "contains...",
    "in_progress": "In Progress",
    "last_seen": "Last seen",
    "mark_as_not_started": "MARK AS NOT STARTED",
    "lock": "LOCK",
    "unlock": "UNLOCK",
    "lock_course_confirm": "This will lock the course so the user cannot open it. Proceed?",
    "unlock_course_confirm": "This will unlock the course so the user can open it. Proceed?",
    "reset_timer_time_left": "RESET TIMER ({timeLeft} left)",
    "reset_timer_time_expired": "RESET TIMER (No time left)",
    "reset_timer_timer_not_started": "TIMER NOT STARTED",
    "no_user_selected": "No User Selected",
    "pagination_limit": "Limit: {limit}",
    "pagination_results_found": "{num, plural, one {# result found} other {# results found}}",
    "quick_search_placeholder": "Filter results...",
    "quick_search_reset": "Reset Filter",
    "refresh": "Refresh",
    "registered_x": "Registered {date}",
    "report_title_placeholder": "Report",
    "report_title_users": "Users",
    "report_title_player_lesson_sessions": "Lesson Sessions",
    "report_title_editor_lesson_sessions": "Editor Sessions",
    "reports_title": "REPORTS",
    "reset_course_confirm": "This will reset the course to appear as not started to the learner. Proceed?",
    "reset_timer_confirm": "This will reset the timer on the exam so the user can open it again. Proceed?",
    "reset_at": "Reset",
    "show_not_started": "SHOW NOT STARTED COURSES",
    "started": "Started",
    "th_name": "Name",
    "th_registered": "Registered",
    "th_account_id": "Username",
    "th_client_type": "Client",
    "th_courses": "Courses",
    "th_course": "Course",
    "th_lesson": "Lesson",
    "th_lessons": "Lessons",
    "th_status": "Status",
    "th_started": "Started",
    "th_completed": "Completed",
    "th_total_time": "Total Time",
    "th_assessment_group": "Assessment",
    "th_assessment_first": "First",
    "th_assessment_best": "Best",
    "th_assessment_score_first": "First Score",
    "th_assessment_score_best": "Best Score",
    "th_assessment_attempts_total": "# Completions",
    "th_last_seen": "Last Seen",
    "th_started_in_this_session": "First Session",
    "th_completed_in_this_session": "Completed",
    "th_save_count": "Saves",
    "to_use_user_report": "To use this report, search for users in the <strong>Activity Report</strong>, then click a user's email to view their details here.",
    "user": "User Detail",
    "view_activity_report": "VIEW ACTIVITY REPORT",
    "x_available_courses": "{num} available courses",
    "x_completed": "{num} completed",
    "x_in_progress": "{num} in progress",
    "status_started": "Started",
    "status_not_started": "Not Started",
    "status_completed": "Completed"
}
};window.locales.es = window.locales.es || {};window.locales.es.reports = window.locales.es.reports || {};window.locales.es.reports.reports = window.locales.es.reports.reports || {};window.locales.es.reports.reports = {...window.locales.es.reports.reports, ...{
    "confirm_title": "¿Estás seguro?",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "action_failed": "El cambio no se ha guardado. Por favor, inténtalo de nuevo.",
    "date_range_interval": "Intervalo de fechas",
    "date_range_start": "Fecha de inicio",
    "date_range_finish": "Fecha de finalización",
    "date_range_label_last_days": "{value, plural, one {Último # día} other {Últimos # días}}",
    "date_range_label_last_weeks": "{value, plural, one {Última # semana} other {Últimas # semanas}}",
    "date_range_label_last_months": "{value, plural, one {Último # mes} other {Últimos # meses}}",
    "date_range_label_since_date": "Desde el {start}",
    "date_range_label_between_dates": "Entre {start} y {end}",
    "filter_search_placeholder": "Buscar...",
    "maintenance_message": "Los informes se encuentran actualmente en estado de mantenimiento rutinario. ¡Por favor, inténtalo de nuevo en breve!",
    "no_report_loaded_message": "Selecciona las opciones de filtro anteriores. Haz clic en <refreshButton>Refrescar</refreshButton> para cargar los datos.",
    "no_results_found_message": "¡No se han encontrado resultados! Ajusta los filtros o haz clic en <clearButton>Eliminar</clearButton> para empezar de nuevo.",
    "report_load_failed": "El informe no se ha cargado. Por favor, inténtalo de nuevo.",
    "activity": "Informe de la actividad",           
    "apply": "Aplicar",           
    "clear": "Eliminar",           
    "completed_subtext": "Completado",           
    "date_range_interval_between": "Entre",           
    "date_range_interval_last": "Últimos",           
    "date_range_interval_since": "Desde",           
    "date_range_unit_days": "días",           
    "date_range_unit_months": "meses",           
    "date_range_unit_weeks": "semanas",           
    "refresh": "Refrescar",           
    "report_title_placeholder": "Informe",           
    "reports_title": "INFORMES",           
    "user": "Detalle del usuario",           
    "course_activity": "ACTIVIDAD DEL CURSO",           
    "export_as_csv": "Exportar como CSV",           
    "last_seen": "Visto por última vez ",           
    "no_user_selected": "Ningún usuario seleccionado",           
    "pagination_results_found": "{num, plural, one {# resultado encontrado} other {# resultados encontrados}}",
    "quick_search_placeholder": "Filtrar resultados...",           
    "quick_search_reset": "Reiniciar filtro",           
    "registered_x": "Registrado {date}",           
    "report_title_users": "Usuarios",           
    "show_not_started": "MOSTRAR CURSOS NO INICIADOS",           
    "started": "Empezado",           
    "th_name": "Nombre",           
    "th_registered": "Registrado",           
    "th_courses": "Cursos",           
    "th_lesson": "Lección",           
    "th_course": "Curso",           
    "th_lessons": "Lecciones",           
    "th_started": "Empezado",           
    "th_completed": "Terminado",           
    "th_total_time": "Tiempo total",           
    "th_last_seen": "Visto por última vez ",           
    "to_use_user_report": "Para utilizar este informe, busca usuarios en el <strong>Informe de actividad</strong> y, a continuación, haz clic en correo electrónico de un usuario para ver sus detalles aquí.",           
    "view_activity_report": "VER INFORME DE ACTIVIDAD",           
    "x_available_courses": "{num} cursos disponibles",           
    "x_completed": "{num} completados",           
    "x_in_progress": "{num} en curso",           
    "in_progress": "En curso",           
    "program": "Programa",
    "file_name_activity_report": "actividad_usuarios",           
    "file_name_course_activity": "actividad_cursos_usuario",           
    "th_status": "Estado",           
    "status_started": "Empezado",           
    "status_not_started": "No empezado",           
    "status_completed": "Completado",           
    "date_range_label_show_all": "Mostrar todo",           
    "report_title_player_lesson_sessions": "Sesiones de lecciones",           
    "th_started_in_this_session": "Primera sesión",           
    "th_completed_in_this_session": "Completada",           
    "report_title_editor_lesson_sessions": "Sesiones del editor",           
    "th_save_count": "Guardadas",           
    "th_assessment_group": "Evaluación",           
    "th_assessment_first": "Primer",           
    "th_assessment_best": "Mejor",
    "th_assessment_score_first": "Primer Puntaje",           
    "th_assessment_attempts_total": "# Terminados",           
    "filter_label_username_or_name": "Nombre de usuario o nombre",           
    "filter_label_cohorts": "Cohortes",           
    "filter_label_courses": "Cursos",           
    "filter_label_courses_completed": "Cursos completados",           
    "filter_label_courses_started": "Cursos iniciados",           
    "filter_label_groups": "Grupos",           
    "filter_label_institutions": "Instituciones",           
    "filter_label_roles": "Funciones",           
    "filter_label_sign_up_codes": "Códigos de registro",           
    "filter_label_lessons": "Lecciones",
    "filter_label_locale": "Idioma",
    "filter_label_client_types": "Cliente",
    "filter_placeholder_all": "Todos",
    "filter_placeholder_text": "contiene...",           
    "th_account_id": "Nombre de usuario",           
    "th_client_type": "Cliente",           
    "mark_as_not_started": "MARCAR COMO NO EMPEZADO",           
    "reset_course_confirm": "Esto restablecerá el curso para que aparezca como no iniciado para el alumno. ¿Proceder?",           
    "reset_at": "Reiniciar",           
    "pagination_limit": "Límite: {limit}",
    "th_assessment_score_best": "Mejor puntuación",
    "reset_timer_time_left": "RESET TIMER ( {timeLeft} izquierda)",
    "reset_timer_time_expired": "RESET TIMER (Sin tiempo restante)",
    "reset_timer_timer_not_started": "TIMER NO INICIADO",
    "reset_timer_confirm": "Esto restablecerá el temporizador en el examen para que el usuario pueda abrirlo de nuevo. ¿Proceder?",
    "lock": "CERRAR",
    "unlock": "DESBLOQUEAR",
    "lock_course_confirm": "Esto bloqueará el curso para que el usuario no pueda abrirlo. ¿Proceder?",
    "unlock_course_confirm": "Esto desbloqueará el curso para que el usuario pueda abrirlo. ¿Proceder?"
}
};window.locales.it = window.locales.it || {};window.locales.it.reports = window.locales.it.reports || {};window.locales.it.reports.reports = window.locales.it.reports.reports || {};window.locales.it.reports.reports = {...window.locales.it.reports.reports, ...{
    "confirm_title": "Sei sicuro?",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "action_failed": "La modifica non è stata salvata. Per favore, riprova.",
    "date_range_interval": "Intervallo di date",
    "date_range_start": "Data di inizio",
    "date_range_finish": "Data di fine",
    "date_range_label_last_days": "{value, plural, one {Ultimo # giorno} other {Ultimi # giorni}}",
    "date_range_label_last_weeks": "{value, plural, one {Ultima # settimana} other {Ultime # settimane}}",
    "date_range_label_last_months": "{value, plural, one {Ultimo # mese} other {Ultimi # mesi}}",
    "date_range_label_since_date": "Da {start}",
    "date_range_label_between_dates": "Fra {start} e {end}",
    "filter_search_placeholder": "Cerca...",
    "maintenance_message": "I riepiloghi sono attualmente in corso di consueta manutenzione. Per favore, riprova fra un po''!",
    "no_report_loaded_message": "Seleziona le opzioni filtro in alto. Fai clic su <refreshButton>Aggiorna</refreshButton> per caricare i dati.",
    "no_results_found_message": "Nessun risultato trovato! Regola i filtri o fai clic su <clearButton>Cancella</clearButton> per ricominciare.",
    "report_load_failed": "Il riepilogo non è stato caricato. Per favore, riprova.",
    "activity": "Riepilogo Attività",           
    "apply": "Candidati",           
    "clear": "Cancella",           
    "completed_subtext": "Completato",           
    "program": "Programma",
    "course_activity": "ATTIVITÀ CORSO",           
    "date_range_interval_between": "Fra",           
    "date_range_interval_last": "Ultimo",           
    "date_range_interval_since": "Da",           
    "date_range_label_show_all": "Mostra tutto",           
    "date_range_unit_days": "giorni",           
    "date_range_unit_months": "mesi",           
    "date_range_unit_weeks": "settimane",           
    "export_as_csv": "Esporta come CSV",           
    "file_name_activity_report": "attività_utente",           
    "file_name_course_activity": "attività_corsi_utente",           
    "filter_label_username_or_name": "Nome utente o nome",           
    "filter_label_cohorts": "Sessioni Accademiche",           
    "filter_label_courses": "Corsi",           
    "filter_label_courses_completed": "Corsi completati",           
    "filter_label_courses_started": "Corsi iniziati",           
    "filter_label_groups": "Gruppi",           
    "filter_label_institutions": "Istituzioni",           
    "filter_label_roles": "Posizioni",           
    "filter_label_sign_up_codes": "Codici Registrazione",           
    "filter_label_lessons": "Lezioni",
    "filter_label_locale": "Località",
    "filter_label_client_types": "Client",
    "filter_placeholder_all": "Tutto",
    "filter_placeholder_text": "contiene…",           
    "in_progress": "In corso",           
    "last_seen": "Ultima visione",           
    "mark_as_not_started": "SEGNA COME NON INIZIATO",           
    "reset_timer_time_left": "REIMPOSTA TIMER ({timeLeft} left)",           
    "reset_timer_time_expired": "REIMPOSTA TIMER (Nessun tempo residuo)",           
    "reset_timer_timer_not_started": "TIMER NON PARTITO",           
    "no_user_selected": "Nessun utente selezionato",           
    "pagination_limit": "Limite: {limit}",           
    "pagination_results_found": "{num, plural, one {# risultato trovato} other {# risultati trovati}}",
    "quick_search_placeholder": "Filtra risultati…",           
    "quick_search_reset": "Reimposta Filtro",           
    "refresh": "Aggiorna",           
    "registered_x": "Registrato {date}",           
    "report_title_placeholder": "Riepilogo",           
    "report_title_users": "Utenti",           
    "report_title_player_lesson_sessions": "Sessioni Lezione",           
    "report_title_editor_lesson_sessions": "Sessioni Editor",           
    "reports_title": "RIEPILOGHI",           
    "reset_course_confirm": "Questo reimposterà il corso affinché appaia allo studente come non ancora iniziato. Procedere?",           
    "reset_timer_confirm": "Questo reimposterà il timer dell'esame affinché lo studente possa aprirlo di nuovo. Procedere?",           
    "reset_at": "Reimposta",           
    "show_not_started": "MOSTRA CORSI NON ANCORA INIZIATI",           
    "started": "Iniziato",           
    "th_name": "Nome",           
    "th_registered": "Registrato",           
    "th_account_id": "Nome Utente",           
    "th_client_type": "Client",           
    "th_courses": "Corsi",           
    "th_course": "Corso",           
    "th_lesson": "Lezione",           
    "th_lessons": "Lezioni",           
    "th_status": "Stato",           
    "th_started": "Iniziato",           
    "th_completed": "Completato",           
    "th_total_time": "Tempo totale",           
    "th_assessment_group": "Valutazione",           
    "th_assessment_first": "Primo",           
    "th_assessment_best": "Migliore",           
    "th_assessment_score_first": "Primo Punteggio",           
    "th_assessment_score_best": "Miglior Punteggio",           
    "th_assessment_attempts_total": "# Completamenti",           
    "th_last_seen": "Ultima Visione",           
    "th_started_in_this_session": "Prima Sessione",           
    "th_completed_in_this_session": "Completata",           
    "th_save_count": "Salvataggi",           
    "to_use_user_report": "Per usare questo riepilogo, cerca gli utenti nel <strong>Riepilogo Attività</strong>, quindi fai clic sulla email di un utente per visualizzare qui i dettagli.",           
    "user": "Dettaglio Utente",           
    "view_activity_report": "VISUALIZZA RIEPILOGO ATTIVITÀ",           
    "x_available_courses": "{num} corsi disponibili",           
    "x_completed": "{num} completati",           
    "x_in_progress": "{num} in corso",           
    "status_started": "Iniziato",           
    "status_not_started": "Non iniziato",           
    "status_completed": "Completato",           
    "lock": "SERRATURA",
    "unlock": "SBLOCCARE",
    "lock_course_confirm": "Questo bloccherà il corso in modo che l'utente non possa aprirlo. Procedere?",
    "unlock_course_confirm": "Questo sbloccherà il corso in modo che l'utente possa aprirlo. Procedere?"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.reports = window.locales.zh.reports || {};window.locales.zh.reports.reports = window.locales.zh.reports.reports || {};window.locales.zh.reports.reports = {...window.locales.zh.reports.reports, ...{
    "confirm_title": "确定吗？",
    "confirm": "确认",
    "cancel": "取消",
    "action_failed": "更改未保存。请重试。",
    "date_range_interval": "日期范围",
    "date_range_start": "开始日期",
    "date_range_finish": "结束日期",
    "date_range_label_last_days": "{value, plural, other {最近 # 天}}",
    "date_range_label_last_weeks": "{value, plural, other {最近 # 周}}",
    "date_range_label_last_months": "{value, plural, other {最近 # 个月}}",
    "date_range_label_since_date": "自从 {start}",
    "date_range_label_between_dates": "在 {start} 与 {end} 之间",
    "filter_search_placeholder": "搜索...",
    "maintenance_message": "报告当前正在进行例行维护。请稍后再试！",
    "no_report_loaded_message": "在上面选择筛选选项。请单击<refreshButton>刷新</refreshButton>以加载数据。",
    "no_results_found_message": "未找到任何结果！请调整筛选条件或者单击<clearButton>清除</clearButton>以重新开始。",
    "report_load_failed": "报告未能加载。请重试。",
    "activity": "活动报告",           
    "apply": "申请",           
    "clear": "清除",           
    "completed_subtext": "已完成",           
    "program": "课程类型",
    "course_activity": "课程活动",           
    "date_range_interval_between": "之间",           
    "date_range_interval_last": "上一个",           
    "date_range_interval_since": "自从",           
    "date_range_unit_days": "天",           
    "date_range_unit_months": "个月",           
    "date_range_unit_weeks": "周",           
    "export_as_csv": "导出为 CSV",           
    "file_name_activity_report": "users_activity",           
    "file_name_course_activity": "user_courses_activity",           
    "in_progress": "正在进行",           
    "last_seen": "最后看到",           
    "no_user_selected": "未选择任何用户",           
    "pagination_results_found": "找到了 {num, number} 个结果。",           
    "quick_search_placeholder": "筛选结果...",           
    "quick_search_reset": "重置筛选条件",           
    "refresh": "刷新",           
    "registered_x": "注册时间 {date}",           
    "report_title_placeholder": "报告",           
    "report_title_users": "用户",           
    "reports_title": "报告",           
    "show_not_started": "显示未开始的课程",           
    "started": "已开始",           
    "th_name": "姓名",           
    "th_registered": "注册时间",           
    "th_courses": "课程",           
    "th_course": "课程",           
    "th_lesson": "课业",           
    "th_lessons": "课业",           
    "th_status": "状态",           
    "th_started": "已开始",           
    "th_completed": "已完成",           
    "th_total_time": "总时间",           
    "th_last_seen": "最后看到",           
    "to_use_user_report": "要使用此报告，请在<strong>活动报告</strong>中搜索用户，然后单击用户的电子邮件在此处查看其详细信息。",           
    "user": "用户详细信息",           
    "view_activity_report": "查看活动报告",           
    "x_available_courses": "{num} 个可用课程",           
    "x_completed": "{num} 个已完成",           
    "x_in_progress": "{num} 个正在进行中",           
    "status_started": "已开始",           
    "status_not_started": "未开始",           
    "status_completed": "已完成",           
    "date_range_label_show_all": "全部显示",           
    "report_title_player_lesson_sessions": "课时",           
    "th_started_in_this_session": "第一课时",           
    "th_completed_in_this_session": "已完成",           
    "report_title_editor_lesson_sessions": "编辑时段",           
    "th_save_count": "保存",           
    "th_assessment_group": "评估",           
    "th_assessment_first": "第一",           
    "th_assessment_best": "最佳",           
    "th_assessment_score_first": "第一名的得分",           
    "th_assessment_attempts_total": "# 完成",           
    "filter_label_username_or_name": "用户名或姓名",           
    "filter_label_cohorts": "同批人",           
    "filter_label_courses": "课程",           
    "filter_label_courses_completed": "已完成课程",           
    "filter_label_courses_started": "已开始课程",           
    "filter_label_groups": "组",           
    "filter_label_institutions": "机构",           
    "filter_label_roles": "角色",           
    "filter_label_sign_up_codes": "注册代码",           
    "filter_label_lessons": "课业",
    "filter_label_locale": "区域设置",
    "filter_label_client_types": "客户端",
    "filter_placeholder_all": "全部",
    "filter_placeholder_text": "包含...",           
    "th_account_id": "用户名",           
    "th_client_type": "客户端",           
    "mark_as_not_started": "标记为未启动",           
    "reset_course_confirm": "这会将课程重置到尚未开始的状态。是否继续？",           
    "reset_at": "重置",           
    "pagination_limit": "限时：{limit}",           
    "th_assessment_score_best": "最佳得分",           
    "reset_timer_time_left": "重置计时器（{timeLeft}剩余）",           
    "reset_timer_time_expired": "重置计时器（无剩余时间）",           
    "reset_timer_timer_not_started": "计时器未开启",           
    "reset_timer_confirm": "这将重置测验计时器，以便用户可再次使用。继续？",           
    "lock": "锁",
    "unlock": "开锁",
    "lock_course_confirm": "这将锁定课程，因此用户无法打开它。继续？",
    "unlock_course_confirm": "这将解锁课程，以便用户可以打开它。继续？"
}
};